/** @format */

import {TFunction} from 'i18next';

import {WidgetStat} from 'components/PropertyWidget/model';
import {ColumnValueText, ValueBox} from 'components/PropertyWidget/style';

import {ChartIds} from '../../models/chartIds';
import {SensorStats, StatsSensorsResult} from '../calculate-stats/statsSensors';
import {WidgetBlockColor} from '../../models/widgets';
import {WidgetSensorButtonWrap} from '../../components/widget-sensor-button-wrap';

export interface GetStatsTypeSensorOptions {
  statsSensorsResult?: StatsSensorsResult;
  chartId: ChartIds;
  sensorColors?: WidgetBlockColor;
  companyId: string;
  t: TFunction;
}

const getStatsTypeSensor = ({
  statsSensorsResult,
  chartId,
  sensorColors,
  companyId,
  t,
}: GetStatsTypeSensorOptions): WidgetStat[] => {
  if (!statsSensorsResult) {
    return [];
  }

  let stats: SensorStats = statsSensorsResult.GRAY;

  if (chartId === 'sensorRed') {
    stats = statsSensorsResult.RED;
  } else if (chartId === 'sensorYellow') {
    stats = statsSensorsResult.YELLOW;
  }

  const {allCount, fixedCount, fixed, newCount, new: newChecks} = stats;
  const allCountPlurals = t('plurals.sensors', {count: allCount});
  const newCountPlurals = t('plurals.sensors_dative', {count: newCount});
  const fixedCountPlurals = t('plurals.sensors_dative', {count: fixedCount});

  if (allCount === 0) {
    const color = sensorColors?.[chartId];
    return [
      {
        heading: (
          <>
            В категории
            <br />
            нет сенсоров
          </>
        ),
      },
      {
        heading: <WidgetSensorButtonWrap bgColor={color || '#FFF'} companyId={companyId} />,
      },
    ];
  }

  return [
    {
      heading: 'В категории',
      ValueComponent: (
        <ValueBox>
          <ColumnValueText>{allCountPlurals}</ColumnValueText>
        </ValueBox>
      ),
    },
    {
      heading: 'Сработало за период',
      ValueComponent: (
        <ValueBox>
          <ColumnValueText>
            {newChecks} по {newCountPlurals}
          </ColumnValueText>
        </ValueBox>
      ),
    },
    {
      heading: 'Исправлено',
      ValueComponent: (
        <ValueBox>
          <ColumnValueText>
            {fixed} по {fixedCountPlurals}
          </ColumnValueText>
        </ValueBox>
      ),
    },
  ];
};

export {getStatsTypeSensor};
